import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IframeAppEmbedderComponent } from "libraries/component/iframe-app-embedder/iframe-app-embedder.component";

@Component({
    selector: 'iframe-app-embedder-ancillary-summary',
    template: `
        <iframe #myIframe
                name="ancillaryServicesSummary"
                scrolling="no"
                [attr.src]="safeUrl"
                [class.full-height]="isFullHeight"
                [class.is-hidden]="isHidden"
                [style.height]="newHeight"></iframe>
    `,
    styles: [`
        iframe {
            border: 0;
            width: 100%;
        }

        iframe.full-height {
            height: 100%;
        }
        iframe.is-hidden {
            display: none;
        }

        :host {
            display: block;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class IframeAppEmbedderAncillaryServicesSummaryComponent extends IframeAppEmbedderComponent{
}
